// extracted by mini-css-extract-plugin
export default {"root":"ExamCountDown_root__Ongxt","countdown":"ExamCountDown_countdown__0bGfJ","tip":"ExamCountDown_tip__63wag","remarks":"ExamCountDown_remarks__iOZG3"};